import axios from 'axios'
import { QueryClient } from '@tanstack/react-query'

const QUERY_STALE_TIME_MS = 1000 * 60 * 5
const QUERY_RETRY_DELAY_MS = 1000
const MAX_TRANSIENT_RETRIES = 1

const isTransientHttpStatus = (status: number) =>
  status === 408 || status === 429 || status >= 500

export const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (!axios.isAxiosError(error) || !error.response) {
    return false
  }

  return (
    failureCount < MAX_TRANSIENT_RETRIES &&
    isTransientHttpStatus(error.response.status)
  )
}

export const createQueryClient = ({
  retryDelay = QUERY_RETRY_DELAY_MS,
}: {
  retryDelay?: number
} = {}) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        refetchOnWindowFocus: false,
        retry: shouldRetryQuery,
        retryDelay,
      },
    },
  })

export const getRefetchIntervalUnlessError = (
  state: { error: unknown },
  interval: number
) => (state.error ? false : interval)
